import { render, staticRenderFns } from "./PartReInsPopupContent.vue?vue&type=template&id=10a789c6&"
import script from "./PartReInsPopupContent.vue?vue&type=script&lang=js&"
export * from "./PartReInsPopupContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports